import React, { FC, HTMLAttributes } from "react"
import { HR } from "../Atoms"
import { H3 } from "@carrotfertility/carotene"
import { SharedInputCssProps } from "./StyledInputs"
import { useFormContext } from "react-hook-form"

export type FormListSingleSelectProps = {
  placeholderText?: string
  options: OptionProps[]
  name?: string
} & Partial<SharedInputCssProps> &
  HTMLAttributes<HTMLInputElement>

type OptionProps = {
  id: string
  title: string
}

const FormListSingleSelect = React.forwardRef<HTMLInputElement, FormListSingleSelectProps>(
  ({ options, name }: FormListSingleSelectProps, ref) => {
    const { watch } = useFormContext()
    return (
      <>
        {options.map((option) => (
          <div key={option.id}>
            <input hidden name={name} id={`option-${option.id}`} type="radio" value={option.id} ref={ref} />
            <FormListSingleSelectOption
              id={option.id}
              title={option.title}
              name={name}
              isSelected={watch(name) === option.id}
            />
          </div>
        ))}
      </>
    )
  }
)
FormListSingleSelect.displayName = "FormListSingleSelect"

type FormListSingleSelectOption = {
  id: string
  title: string
  isSelected: boolean
  name: string
}

const FormListSingleSelectOption: FC<FormListSingleSelectOption> = ({ id, title, isSelected, name }) => {
  const { setValue, trigger } = useFormContext()

  const onChildClickSelected = (id): void => {
    setValue(name, id)
    trigger()
  }

  return (
    <div
      id={`form-list-single-select-${id}`}
      onClick={() => onChildClickSelected(id)}
      className={`pointer bg-${isSelected ? "old-lace" : "white"} animate-all hover-bg-old-lace`}
    >
      <div style={{ padding: "0 48px" }}>
        <div className="hover-black animate-all flex-auto">
          <H3 paddingTopBottom="small">{title}</H3>
          <HR color="black-10" />
        </div>
      </div>
    </div>
  )
}

export { FormListSingleSelect }
